"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_demi_1 = require("vue-demi");
const __sfc_main = {};
__sfc_main.props = {
    tabs: {
        type: Array,
        default: () => []
    },
    activeKey: {
        type: String,
        default: ''
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const props = __props;
    const emit = __ctx.emit;
    const handleTabClick = (key) => {
        emit('tab-click', key);
    };
    // 吸顶相关状态
    const tabsRef = (0, vue_demi_1.ref)(null);
    const listRef = (0, vue_demi_1.ref)(null);
    const isFixed = (0, vue_demi_1.ref)(false);
    const tabHeight = (0, vue_demi_1.ref)(0);
    let initialOffsetTop = 0;
    const handleScroll = () => {
        isFixed.value = window.scrollY >= initialOffsetTop;
    };
    // 滚动 Tab 列表，让激活的 Tab 尽可能居中
    const scrollTabToCenter = (key) => {
        if (!listRef.value)
            return;
        const listEl = listRef.value;
        const tabEl = listEl.querySelector(`[data-key="${key}"]`);
        if (!tabEl)
            return;
        const containerWidth = listEl.clientWidth;
        const scrollWidth = listEl.scrollWidth;
        const tabOffsetLeft = tabEl.offsetLeft;
        const tabWidth = tabEl.offsetWidth;
        // 计算理想滚动位置（让 Tab 居中）
        const idealScrollLeft = tabOffsetLeft - containerWidth / 2 + tabWidth / 2;
        // 限制在有效范围内：[0, maxScrollLeft]
        const maxScrollLeft = scrollWidth - containerWidth;
        const finalScrollLeft = Math.max(0, Math.min(idealScrollLeft, maxScrollLeft));
        listEl.scrollTo({
            left: finalScrollLeft,
            behavior: 'smooth'
        });
    };
    // 监听 activeKey 变化，滚动到对应 Tab
    (0, vue_demi_1.watch)(() => props.activeKey, newKey => {
        if (newKey) {
            scrollTabToCenter(newKey);
        }
    });
    (0, vue_demi_1.onMounted)(() => {
        if (tabsRef.value) {
            tabHeight.value = tabsRef.value.offsetHeight;
            initialOffsetTop = tabsRef.value.getBoundingClientRect().top + window.scrollY;
            window.addEventListener('scroll', handleScroll, {
                passive: true
            });
            handleScroll();
        }
    });
    (0, vue_demi_1.onUnmounted)(() => {
        window.removeEventListener('scroll', handleScroll);
    });
    return {
        handleTabClick,
        tabsRef,
        listRef,
        isFixed,
        tabHeight
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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